import { styled, Typography } from "@monolith-forensics/monolith-ui";
import { CustomFields } from "./CustomFields";

const StyledContainer = styled.div`
  margin-bottom: 20px;
  .message {
    color: ${({ theme }) => theme.palette.text.secondary};
    font-weight: 400;
    font-size: 14px;
    margin-top: 5px;
    margin-bottom: 10px;
  }
`;

export const InquiryCustomFields: React.FC<{
  customFields: any;
}> = ({ customFields }) => {
  return (
    <StyledContainer>
      <Typography variant="h3" display="inline">
        Custom Inquiry Fields
      </Typography>
      <div className="message">
        Set the enabled option for your custom inquiry fields. When enabled, the
        field will be available to the user in Relay when creating a new
        request.
      </div>
      <div
        style={{
          marginTop: 20,
          paddingRight: 20,
          paddingLeft: 5,
        }}
      >
        <CustomFields customFields={customFields} type="inquiry" />
      </div>
    </StyledContainer>
  );
};
